import type { ProjectAnalyticsConfig } from '@yourownmetric/shared'

import type { PrivacyCounts } from '@/apis/opsTypes'

const fmtNum = (n: number) => n.toLocaleString('en-US')

/** Opt-outs that were not honored only exist with `privacy.dnt = ignore`. */
export function privacyVerdict(t: PrivacyCounts): { ok: boolean; text: string } {
    if (t.opt_outs.requests === 0) {
        return { ok: true, text: 'No opt-out requests in this period.' }
    }
    if (t.opt_outs.not_honored === 0) {
        return {
            ok: true,
            text:
                t.opt_outs.requests === 1
                    ? 'The one opt-out request was honored.'
                    : `All ${fmtNum(t.opt_outs.requests)} opt-out requests were honored.`,
        }
    }
    return {
        ok: false,
        text: `${fmtNum(t.opt_outs.not_honored)} of ${fmtNum(t.opt_outs.requests)} opt-out requests were not honored (DNT/GPC policy is "ignore").`,
    }
}

/** The full config with only `privacy` changed: PUT /config replaces the whole document. */
export function withPrivacy(
    config: ProjectAnalyticsConfig,
    privacy: ProjectAnalyticsConfig['privacy'],
): ProjectAnalyticsConfig {
    return { ...config, privacy: { ...config.privacy, ...privacy } }
}
